export const spekwoType = {
    testOrder: 'No product selected Bec Its test order',
    head: 'Solution Estimate Form',
    headForOther: 'Request Details',
    reportId: 'Report Id is :',
    orderDetails: 'Order Details',
    homeIns: 'Home Inspection Report',
    ddra: 'DDRA',
    uniqueReport: 'Unique Report',
    preListPictures: 'Pre-List Pictures',
    supportingReports: 'Supporting Report',

    processReport: 'Uploading...',
    processed: 'Uploaded',
    notProcessed: 'Upload Document',
    submitDocument: 'Upload document',
    clearFile: 'Clear file',
    manualProcessed: 'Uploaded',
    insReport: 'Solution Estimate Form',
    save: 'Save',
    addSolutionsToDB:"Add solutions to database",
    add:"Add",
    view:"View",
    viewEstimationTable:"View estimation table",
    beforeApprove: 'Approve to go to customer',
    afterApprove: 'Approved',
    notProcess: 'Not yet process this order',
    alterSolution: 'Alter Solution',
    fieldTable: {
        categoryNO: 'Category number',
        descPlace: 'R/R Description',
        keyWord: 'Keyword search',
        solution: 'Solution',
        cost: 'Cost',
        costOption:'Cost Option',
        category: 'Category',
        categoryPlace: 'Pick one',
        desc: ' Category Desc',
        soluCategory: 'Category',
        link: 'Remove Row',
        image: 'Image',
        drag: 'Drag me',
        pagination: 'Items per page',
        itemsNumbers : 'Item Numbers',
        description : 'Description',
        picture : 'Picture',
        keyWordsCollection:[
            "key prime category to new solution",
            "keyword 1 to new solution",
            "keyword 2 to new solution",
            "keyword 3 to new solution",
            "keyword 4 to new solution",
            "key phrase to new solution"
        ],
        keyValuesName:[
            'keyPrimCategory',
            'key1',
            'key2',
            'key3',
            'key4',
        ]
    },
    createSolution: 'Add New Solution Estimate Template',
    multipleSolution: 'Add 10 Solution Estimate Template',
    clearRow:'Clear Row',
    print: 'Print Document',
    action: 'Action',
    edit: 'Edit',
    remove: 'Remove',
    saveDragSolution: 'Save Drag Solution',
    openImg: '* Right click the image and choose Open in new tab to see it in full size',
    close: 'Close',
    //Pdf
    downloadPdf: 'Save as Pdf',
    idLabel: 'Unique Code',
    printHead: 'spekwo Solution Estimate',
    preListPrintHead: 'PRE-LIST SPEK-SHEET',
    scheduleInfoTitle: 'Scheduling Info',
    idContent: 'to view your solution estimate or approve work go to  client.spekwo.com   and enter your unique ID. ',
    noInsreportId : 'Unique id will be generated only after we create solution.',
    agent: 'Agent',
    client: 'Client',
    buyerAddress: 'Property Address',
    pdfFooter1: {
        head: 'Who, What,  spekwo, Huh?',
        'one': 'Glad you asked. spekwo is a trusted and neutral party for buyers and sellers. spekwo will create an estimate for the items your home inspection identified as “repair/ replace”.',
        'two': 'We do this by utilizing the most recent data on cost of available labor and materials. ',
        'three': 'If the ordering party elects to have any of the work done a spekwo approved Pro will complete the work at the above price, Guaranteed!'
    },
    pdfFooter2: {
        head: 'How does unique ID work?',
        'one': 'Each spekwo solution estimate completed comes with a unique ID which is a 5 character code. If you would like to view a copy of your home inspection report (the one you submitted)  Or If you would like to view your solution estimate or even if you would like to request some or all of the work quoted to be completed… you can do that all here! ',
        'two': 'Easy just go to ',
        'three': 'and enter your spekwo unique ID, which for yours is: '
    },
    pdfFooter3: {
        head: 'Who is speKwo and What do they do?',
        'one': `We are glad you asked . speKwo is a trusted and neutral party providing quotes for both buyers and sellers.`,
        'two': 'speKwo creates quotes just like this one for our broker clients.  We do this with our proprietary system which quotes all items from your home inspection report utilizing empirical data of labor and material cost for our area.  Not only can we quote the work, but we can complete the work for the price quoted!',
        'three': 'Our team provides quotes and repairs for nearly every real estate firm in the area.',
        'fourth': 'All quotes are valid for 90 days. Quotes are based on pre-allocated measurements which may be subject to change.',
    },
    validQuote: 'This Quote is valid for the next 30 days, after which values may be subject to change.',
    pdfCost: 'Total Quote',

    totalCost: 'Total cost',
    editCategory: 'Edit Category',
    newCategory: 'Add Category',
    update: 'Update',
    updatePage : 'Update Page',
    repairSolutionTitle:"REPAIR SOLUTION",

    info: 'Info',
    owner: 'Owner',
    email: 'Email',
    phone: 'Phone',
    type: 'Type',
    address: 'Buyer Property Address',
    orderAdd: "Order's Address",
    acceptStatus: 'Accept Status',
    acceptBy: 'Accepted By',
    ifAccept: 'Accepted',
    ifNotAccept: 'Not yet accept',
    acceptDate: 'Accepted Date',
    rating: 'Rating',
    createdAt: 'Created at',
    noToggledList: "Client hasn't toggled any solution estimate yet",
    noWorkLIst: "Below options enabled only after client requests the work",
    noPicturesUpload: "No pictures Uploaded",
    saveOrRemove : "Save / Remove ",
    addWork : "Add Work Request Items",

    solutionPage : 'solutionPage',
    requestWorkPageApprove : 'requestWorkPageApprove',

    //after approve solution 
    afterApproveSolution : 'After approving solution cannot edit and delete . You can click Alter Solution to Edit/Remove the solution.',
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/spekwoType.ts